"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_enterprise__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "668d2b2d-8aef-401c-a325-c1efb07776f3",
    x1: 53.81,
    y1: 99.34,
    x2: 121.31,
    y2: 166.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "5bb010d7-2bac-4542-8104-f1222fd0a7e1",
    "data-name": "Enterprise_ic_hi",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,20h64a8,8,0,0,1,8,8V172a0,0,0,0,1,0,0H56a0,0,0,0,1,0,0V28A8,8,0,0,1,64,20Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,20h64a8,8,0,0,1,8,8V172a0,0,0,0,1,0,0H56a0,0,0,0,1,0,0V28A8,8,0,0,1,64,20Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 83,
    width: 66,
    height: 12,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 101,
    width: 66,
    height: 12,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 119,
    width: 66,
    height: 12,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 137,
    width: 66,
    height: 12,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,83H65a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2h62a2,2,0,0,1,2,2V85A2,2,0,0,0,127,83Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,101H65a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2h62a2,2,0,0,1,2,2v-2A2,2,0,0,0,127,101Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,119H65a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2h62a2,2,0,0,1,2,2v-2A2,2,0,0,0,127,119Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,137H65a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2h62a2,2,0,0,1,2,2v-2A2,2,0,0,0,127,137Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 47,
    width: 66,
    height: 12,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 65,
    width: 66,
    height: 12,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,47H65a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2h62a2,2,0,0,1,2,2V49A2,2,0,0,0,127,47Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 29,
    width: 66,
    height: 12,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,29H65a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2h62a2,2,0,0,1,2,2V31A2,2,0,0,0,127,29Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,65H65a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2h62a2,2,0,0,1,2,2V67A2,2,0,0,0,127,65Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 154,
    width: 12,
    height: 18,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116 172.15 78.08 172.15 78.08 75.07 116.01 112.99 116 172.15",
    opacity: 0.2,
    fill: "url(#668d2b2d-8aef-401c-a325-c1efb07776f3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,72H72a8,8,0,0,1,8,8v92a0,0,0,0,1,0,0H24a0,0,0,0,1,0,0V80A8,8,0,0,1,32,72Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 83,
    width: 44,
    height: 12,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 101,
    width: 44,
    height: 12,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 120,
    width: 44,
    height: 11.77,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 138,
    width: 44,
    height: 11.77,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,83H32a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2H72a2,2,0,0,1,2,2V85A2,2,0,0,0,72,83Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,101H32a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2H72a2,2,0,0,1,2,2v-2A2,2,0,0,0,72,101Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,120H32a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2H72a2,2,0,0,1,2,2v-2A2,2,0,0,0,72,120Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,138H32a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2H72a2,2,0,0,1,2,2v-2A2,2,0,0,0,72,138Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 154,
    width: 12,
    height: 18,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,108h40a8,8,0,0,1,8,8v56a0,0,0,0,1,0,0H112a0,0,0,0,1,0,0V116A8,8,0,0,1,120,108Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 119,
    width: 44,
    height: 12,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 137,
    width: 44,
    height: 12,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,119H120a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2h40a2,2,0,0,1,2,2v-2A2,2,0,0,0,160,119Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,137H120a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2h40a2,2,0,0,1,2,2v-2A2,2,0,0,0,160,137Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 154,
    width: 12,
    height: 18,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56 170 24 170 24 172 56 172 136 172 168 172 168 170 136 170 56 170",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 23,
    width: 30,
    height: 4,
    rx: 2,
    ry: 2,
    fill: "#e60000"
  }))), /*#__PURE__*/React.createElement("title", null, "enterprise-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "da7eca39-3318-4628-9e88-f8470f145f08",
    "data-name": "Enterprise_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "3ef52d93-165e-4316-b13f-2f494164021b",
    "data-name": "Enterprise_ic_hi",
    width: 192,
    height: 192,
    transform: "translate(0 0)",
    xlinkHref: "#5bb010d7-2bac-4542-8104-f1222fd0a7e1"
  })));
}

var _default = ic_enterprise__dark;
exports.default = _default;